import { WithChildren } from '~/shared/types/WithChildren';
import { IMarginProps } from '~/shared/interfaces/IMarginProps';

import { Text } from './styles';

import { Collapse } from '../../Collapse';

export const ErrorMessage: WithChildren<IMarginProps & { id?: string }> = ({
  children,
  id,
  m,
  mb,
  mh,
  ml,
  mr,
  mt,
  mv,
}) => {
  return (
    <Collapse isOpen={!!children}>
      <Text id={id} m={m} mb={mb} mt={mt} ml={ml} mr={mr} mv={mv} mh={mh}>
        {children}
      </Text>
    </Collapse>
  );
};
